/**
 * @param dialog {HTMLDialogElement}
 * @return {void}
 */
module.exports = function hideDialog(dialog) {
    dialog.close();
}